const state = {
  authSettled: false,

  loggedIn: false,

  isAnonymous: false,

  user: {},

  userData: {
    name: "",
    email: "",
    emailVerified: false,
    photo: "",
  },
};

const mutations = {
  authSettledMutation: (state, payload) => {
    state.authSettled = payload;
  },

  loggedInMutation: (state, payload) => {
    state.loggedIn = payload;
  },

  isAnonymousMutation: (state, payload) => {
    state.isAnonymous = payload;
  },

  userMutation: (state, payload) => {
    state.user = payload;
  },

  userDataMutation: (state, payload) => {
    state.userData = payload;
  },
};

const actions = {
  authSettledAction: ({ commit }, payload) => {
    commit("authSettledMutation", payload);
  },

  loggedInAction: ({ commit }, payload) => {
    commit("loggedInMutation", payload);
  },

  isAnonymousAction: ({ commit }, payload) => {
    commit("isAnonymousMutation", payload);
  },

  userAction: ({ commit }, payload) => {
    commit("userMutation", payload);
  },

  userDataAction: ({ commit }, payload) => {
    commit("userDataMutation", payload);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
